import { cn } from '@rematter/ui-web';

export type ContentBoxProps = {
  children: React.ReactNode;
  className?: string;
};

export const ContentBox = ({ children, className }: ContentBoxProps) => (
  <div
    className={cn(
      '@ContentBox light flex size-full flex-col rounded-[10px] border border-neutral/20 p-3',
      className,
    )}
  >
    {children}
  </div>
);
